import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//工作量相关API

const courseAdjustSkillsTraining = {
    courseAdjust: {
        queryList: config => createAPI('/courseAdjustSkillsTraining/queryList', 'post', config),
        initOption: config => createAPI('/courseAdjustSkillsTraining/initOption', 'post', config),
        teacherOption: config => createAPI('/courseAdjustSkillsTraining/teacherOption', 'post', config),
        majorOption: config => createAPI('/courseAdjustSkillsTraining/majorOption', 'post', config),
        classOption: config => createAPI('/courseAdjustSkillsTraining/classOption', 'post', config),
        courseOption: config => createAPI('/courseAdjustSkillsTraining/courseOption', 'post', config),
        skzcOption: config => createAPI('/courseAdjustSkillsTraining/skzcOption', 'post', config),
        weekOption: config => createAPI('/courseAdjustSkillsTraining/weekOption', 'post', config),
        jcOption: config => createAPI('/courseAdjustSkillsTraining/jcOption', 'post', config),
        adjustReasonOption: config => createAPI('/courseAdjustSkillsTraining/adjustReasonOption', 'post', config),
        siteOption: config => createAPI('/courseAdjustSkillsTraining/siteOption', 'post', config),
        saveAdjust: config => createAPI('/courseAdjustSkillsTraining/saveAdjust', 'post', config),
        checkApplyUsed: config => createAPI('/courseAdjustSkillsTraining/checkApplyUsed', 'post', config),
        auditReject: config => createAPI('/courseAdjustSkillsTraining/auditReject', 'post', config),
        queryAuditFlow: config => createAPI('/courseAdjustSkillsTraining/queryAuditFlow', 'post', config),

        uploadMultiFile: config => createAPI('/courseAdjustSkillsTraining/uploadMultiFile', 'post', config),
        attachmentList: config => createAPI('/courseAdjustSkillsTraining/attachmentList', 'post', config),
        delFile: config => createAPI('/courseAdjustSkillsTraining/delFile', 'post', config),
        updateAuditState: config => createAPI('/courseAdjustSkillsTraining/updateAuditState', 'post', config),
        yjhskzcOption: config => createAPI('/courseAdjustSkillsTraining/yjhskzcOption', 'post', config),
        yjhxqOption: config => createAPI('/courseAdjustSkillsTraining/yjhxqOption', 'post', config),
        yjhsjxlOption: config => createAPI('/courseAdjustSkillsTraining/yjhsjxlOption', 'post', config),
        teaAndSiteOption: config => createAPI('/courseAdjustSkillsTraining/teaAndSiteOption', 'post', config),
        tzhskzcOption: config => createAPI('/courseAdjustSkillsTraining/tzhskzcOption', 'post', config),
        tzhxqOption: config => createAPI('/courseAdjustSkillsTraining/tzhxqOption', 'post', config),
        tzhsjxlOption: config => createAPI('/courseAdjustSkillsTraining/tzhsjxlOption', 'post', config),
        checkEnableSite: config => createAPI('/courseAdjustSkillsTraining/checkEnableSite', 'post', config),
        checkUnauditAdjust: config => createAPI('/courseAdjustSkillsTraining/checkUnauditAdjust', 'post', config),

        queryList_monitor: config => createAPI('/courseAdjustSkillsTraining/queryList_monitor', 'post', config),
        monitorConfirm: config => createAPI('/courseAdjustSkillsTraining/monitorConfirm', 'post', config),
        queryclass: config => createAPI('/courseAdjustSkillsTraining/queryclass', 'post', config),
        exportAdjustInfo: config => createAPI('/courseAdjustSkillsTraining/exportAdjustInfo', 'post', config),
        queryBtkxx: config => createAPI('/courseAdjustSkillsTraining/queryBtkxx', 'post', config),
    },
    historyAdjust: {
        queryList: config => createAPI('/historyAdjustSkillsTraining/queryList', 'post', config),
        initOption: config => createAPI('/historyAdjustSkillsTraining/initOption', 'post', config),
        classSkillsTraining: config => createAPI('/historyAdjustSkillsTraining/classSkillsTraining', 'post', config),
        submit: config => createAPI('/historyAdjustSkillsTraining/submit', 'post', config),
    }
};


export default courseAdjustSkillsTraining;



// WEBPACK FOOTER //
// ./src/api/modules/courseAdjustSkillsTraining.js